<template>
  <b-modal id="modal-2">
    <!--Content-->
    <template slot="modal-header">
      <div class>
        <!--Header-->
        <div>
          <i
            class="fa fa-2x fa-orange fa-exclamation-triangle mb-3 slow-spin animated"
          ></i>
        </div>
      </div>
    </template>

    <!--Body-->
    <div class="modal-body">
      <div style="float: left;">
        <p>
          Are you sure you want to delete this
          <slot name="entityType" />?
        </p>
        <span class="heading lead" style="text-align: left;">
          <slot name="header"></slot>
        </span>
        <span class="heading lead" style="text-align: left;">
          <slot name="details"></slot>
        </span>
      </div>
    </div>

    <!--Footer-->
    <template slot="modal-footer">
      <div
        slot
        class="modal-footer justify-content-center"
        style="border:none;"
      >
        <b-button
          class="mr-2"
          type="submit"
          size="md"
          variant="outline-primary"
          data-dismiss="modal"
          @click="$bvModal.hide('modal-2')"
          aria-label="Close"
          >Cancel</b-button
        >
        <a
          type="button"
          class="btn btn-primary text-white"
          @click="DeleteConfirmed"
        >
          Yes, I'm sure
          <i class="fa fa-trash-o ml-1 text-white"></i>
        </a>
      </div>
    </template>

    <!--/.Content-->
  </b-modal>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  data() {
    return {
      isUsingGlobalService: false,
      deleteOp: {}
    };
  },
  computed: {
    ...mapState(["n_user", "product", "global"]),
    ...mapActions("n_user", ["Delete"]),
    ...mapActions("n_user", ["DeleteUserGroup"])
  },
  methods: {
    DeleteConfirmed() {
      var _command = "";
      switch (this.EntityType) {
        case "N_User":
          _command = "n_user/Delete";
          break;
        case "N_UserGroup":
          _command = "n_user/DeleteUserGroup";
          break;
        case "Product":
          _command = "product/DeleteProduct";
          break;
        case "Player":
          _command = "player/Delete";
          break;
        case "Venue":
          _command = "venue/Delete";
          break;
        case "Sponsor":
          _command = "sponsor/Delete";
          break;
        case "Dealer":
          _command = "dealer/Delete";
          break;
        case "DealerGroup":
          _command = "dealer/DeleteGroup";
          break;
        case "EmailTemplateLink":
          _command = "emailtemplate/DeleteLink";
          break;
        case "Tournament":
          _command = "tournament/Delete";
          break;
        case "Contact":
          _command = "contact/Delete";
          break;
        case "Team":
          _command = "team/Delete";
          break;
        case "ProductTag":
          _command = "product/DeleteProductTag";
          break;
        case "Order":
          this.isUsingGlobalService = true;
          this.deleteOp = {
            ObjectName: "Order",
            ObjectKey: this.CurrentObject.OrderID
          };
          //_command = "order/DeleteOrder";
          break;
        case "EmailTemplateBoost":
          this.isUsingGlobalService = true;
          this.deleteOp = {
            ObjectName: "EmailTemplateBoost",
            ObjectKey: this.CurrentObject.EmailTemplateBoostID,
            Callback: "emailtemplate/DeleteBoostLink",
            CallbackParameter: this.CurrentObject
          };
          //_command = "order/DeleteOrder";
          break;
        case "InventoryTransaction":
          _command = "product/DeleteTransaction";
          break;
        case "PointTransaction":
          _command = "n_user/DeleteTransaction";
          break;
      }
      if (this.isUsingGlobalService) {
        this.$store.dispatch("global/Delete", this.deleteOp).then(response => {
          this.$bvModal.hide("modal-2");
          this.$emit("filterList");
        });
      } else {
        this.$store.dispatch(_command, this.CurrentObject).then(response => {
          this.$bvModal.hide("modal-2");
          this.$emit("filterList");
        });
      }
      // this.$store
      //   .dispatch("n_user/Delete", this.CurrentObject)
      //   .then(response => {
      //     this.$bvModal.hide("modal-2");
      //   });
      //this.$store.dispatch("n_user/Delete", this.CurrentObject);
    }
  },
  props: {
    CurrentObject: { type: Object },
    EntityType: ""
  },
  updated() {}
};
</script>
